module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("General information")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "noindentt",
    attrs: {
      "id": "sec1"
    }
  }, [_vm._v("Equipment")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Like most tasks, constructing a smocked garment is made easier if you have the right equipment.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg4.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg4-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Sewing machines")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A sewing machine is a vital piece of equipment for quick construction of a garment. A machine is a major investment, and a top-of-the-range model can cost over a thousand pounds. Look carefully at what is available and choose a machine that best suits your needs. Constructing a smocked garment requires very basic machine features such as straight and zigzag stitches and a good buttonhole. It is a waste to spend money on extra features that you will never use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Place the machine on a flat, even working surface with adequate surrounding space to store other sewing requirements.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once you have a machine, taking good care of it ensures that it will last a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fluff and dust will collect under the base plate and should be removed regularly to keep the machine running smoothly. This is particularly important if you are regularly sewing velvet, corduroy or any other pile fabric that will shed large amounts of fibre.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regular oiling will keep the machine running smoothly. Read the machine manual to determine if, where and how often the machine should be oiled. Have it serviced annually by a qualified mechanic and keep it covered and in a dry place when not in use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If travelling with your machine, place a piece of soft fabric on the base plate and ensure that the presser foot is down. Computerised machines can be temperamental and may not like being moved at all.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Machine presser feet")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sewing machines come with several interchangeable feet, each one designed for a specific purpose. Read the machine manual to determine the correct use for each foot. It is well worth purchasing a twin needle foot if your machine does not come with one.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Scissors")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Good quality, sharp dressmaking scissors will make cutting out the garment easy. These are usually 18–20cm (7–8”) in length. Smaller sewing scissors, 11.5–14cm (4½–5½”) in length, are useful for trimming and clipping. Choose scissors that are comfortable to hold and do not cause hand strain when used for long periods of time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Scissors are available with metal, plastic or special ‘soft grip’ handles. If you suffer from arthritis, you may find scissors with larger finger holes helpful. Use the full blade when cutting as this ensures a straight cut edge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Have scissors professionally sharpened as soon as they show signs of wear. Dead spots along the length or at the tip of the scissor blades are a common sign of wear. Take extra care not to drop scissors as this can damage the blades beyond repair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep scissors lubricated by occasionally placing a small drop of oil onto the screw. Wipe away any excess before using.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Store scissors in a safe place to ensure that they are not used in an inappropriate manner.")])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Thread nippers")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("These handy thread clips are useful for general trimming and for getting into tight spots. They can be hung around the neck or kept close to the sewing machine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Rotary cutters")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Excellent for cutting bias or straight strips of fabric and other cutting jobs. Replace the blade as soon as it shows wear. Usually used in conjunction with a special cutting mat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Cutting tables")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you have space, a cutting table gives a wonderful surface for laying and cutting out fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most cutting tables are lightweight and can be folded up and stored away.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Seam rippers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A good seam ripper or quick unpick is invaluable when sewing. This handy little tool makes unpicking easy by cutting the sewing threads along the seam. It is also used to cut open machine buttonholes after they are stitched. Keep one handy by your sewing machine.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Fabric markers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Marking pens are very handy for transferring any temporary pattern or design markings onto fabric. There are several different types available so choose the one that best suits your needs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Water-soluble markers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These are chemical-based and leave blue marks that can be removed with water. Do not iron before removing – heat may affect the marks and make them difficult to remove.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fade-away markers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These are also chemical-based, leave a purple mark and will fade away by themselves. This can happen in five minutes or take several hours. Do not iron before removing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chalk-based pencils")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These are excellent for use on dark coloured fabrics as they come in white, pink and blue. The chalk ‘lead’ is enclosed in wood, making them easy to use. Sharpen regularly as the soft chalk blunts easily.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tailor’s chalk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This comes in a pressed block, and is the forerunner of the pencil. Both chalk based products are removed by brushing or sponging with a damp cloth.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Rulers and tape measures")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Long rulers (metal or wood)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Useful for marking long lines on fabric such as cutting lines, bindings and bias strips.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dressmaker’s squares")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Useful for checking if fabric is true to grain and for determining the true bias. They are invaluable for ruling lines that are at right angles to each other.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tape measures")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A tape measure is a pliable measuring device useful for all types of measuring jobs. Choose a tape that begins the numbering from both ends and has metric and imperial measurements.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg5-2.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Needles")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sewing machine needles are available in different sizes, ranging from the finest (size 60) to the coarsest (size 110). Choose a needle that is suited to the type and weight of fabric that you are using and replace it regularly. Discard needles that are bent or burred as they can cause irreparable damage to fabric and are difficult to stitch with. A damaged needle can also result in the machine skipping stitches. Hand sewing needles are essential for all of those small stitching jobs that cannot be done on the machine. A crewel (embroidery) needle is suitable for most tasks such as tacking, slipstitching, hemming, sewing on buttons, working thread loops and sewing on trims.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg6-1.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Pins")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A wide variety of pins is available, varying in length, diameter and type of head. It is well worth investing in several packets of fine, glass-headed pins that will last for many years and make pinning a pleasure. Glass heads will not melt if ironed and are easy to find if dropped onto the floor. Silk pins have longer and finer shafts than regular pins and glide easily through most fabrics. They are available with plain or glass heads. Discard any pins that are burred, bent or damaged in any way. Store pins in a sealed, moisture-proof container to prevent rust.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg6-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg6-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tnote"
  }, [_vm._v("* "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pin diameters under 1mm do not have imperial measurement equivalents.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg8.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Thimbles")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thimbles are available in a number of different materials including plastic, leather, metal and ceramic. A thimble protects the top of the finger that is used to push the needle through the fabric. Choose a thimble that fits snugly over your finger.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Irons")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Irons can vary from simple models that cost a few dollars, to deluxe ironing systems that include large water reservoirs and suction boards. Common problems with irons are scale buildup in the water tank and a dirty soleplate. Using distilled water or buying an iron with a filter can help to alleviate the scale problem. Cleaning the iron regularly will keep the soleplate in good order.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Puff irons")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("An ingenious device for pressing puffed sleeves. The egg-shaped tool is clamped to a table top. The sleeve is rubbed over the heated puff iron to remove any creases.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg8-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Ironing boards")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Choose a sturdy board with a smooth padded cover. Keep the cover clean to prevent dirt transferring to the fabric that is being pressed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Sleeve boards")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A sleeve board is a smaller version of an ironing board. It enables you to press a greater variety of garments and their component parts in the round.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Pressing hams")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A pressing ham takes its name from its similarity in shape to the cured meat. It is a very firmly filled pillow of fabric, usually wool on one side and cotton on the other. A ham is used for pressing small areas that are difficult to reach on a flat surface. It is also used for pressing curves and rolling collars.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Pressing rolls")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A pressing roll is similar to a ham but cylindrical in shape. It is particularly useful for pressing sleeves and other parts of a garment that cannot be laid flat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Pressing mitts")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A glove-shaped pressing device, the mitt is worn on the hand and pushed into areas that cannot be laid flat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Pressing cloths")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chemically treated pressing cloths are used when steam ironing and are excellent for setting pleats and removing creases. Rectangles of cotton fabric are useful for pressing delicate fabrics, fusing interfacing and appliqué.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flannelette or fine towelling are helpful when pressing embroidery. Fold the fabric into a pad, place beneath the embroidery and press the back of the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Velvet boards or pin boards")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A pin board is invaluable when using fabric with a nap such as corduroy or velvet. It resembles a miniature bed of nails. The fabric is laid face down onto the board and pressed from the back. The pins prevent the nap from being pressed flat.")])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg8-2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "noindentt",
    attrs: {
      "id": "sec2"
    }
  }, [_vm._v("Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fabric is the foundation for every garment and there is an enormous range available for making into smocked clothing. They can be made of natural fibres, synthetic fibres or a combination of the two. Natural fibres such as pure cotton, linen and silk crease easily so they should be chosen for garments that will not be spoiled by wrinkling. Manmade fibres such as polyester are added to natural fibres to help eliminate crushability. Your choice of fabric will be determined by several factors including budget, availability and function of the garment. When buying fabric, take note of the care requirements and pre-wash fabrics that may shrink.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Always test-pleat a sample of the fabric you intend to use to determine its suitability before you begin a project. When test-pleating, use the same number of needles that you will use in the actual project. A fabric that pleats easily with only a few needles may behave differently with twenty-four needles. Use a 30cm (12”) width of fabric as a sample piece.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Check the entire length of fabric for faults or flaws before positioning the pattern and cutting the material to size. Remove selvedges.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ensure that the cut ends of the fabric are straight and follow the grainline. This can be done by pulling a thread across the width and cutting along this line. Most fabrics will tear along the weft grainline but care must be taken that this does not stretch the torn edge or create bruising in the fabric. Once the ends are straightened, check that the fabric is running true to the grain. The warp and weft threads should be resting at right angles to one another. If they are not the straight edge of the fabric will not be at a right angle to the selvedge. Re-align the threads by pulling the fabric at the diagonal corners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before pleating printed fabrics, check that the print runs true to the weft grainline. If not, the print can create unsightly sloping lines once the fabric is pleated.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-1"
  }, [_vm._v("Terminology")]), _vm._v(" "), _c('p', {
    staticClass: "box-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Selvedge")])]), _vm._v(" "), _c('p', {
    staticClass: "box-2"
  }, [_vm._v("The reinforced edge of the fabric. It can be closely woven so trim it away before pleating and constructing the garment.")]), _vm._v(" "), _c('p', {
    staticClass: "box-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Warp and weft threads")])]), _vm._v(" "), _c('p', {
    staticClass: "box-2"
  }, [_vm._v("The names for the two sets of threads that are required for the manufacture of woven fabrics. Warp threads are the weaving threads that run from the front to the back of the weaving loom, parallel to the selvedge. Weft threads, or filling, are the set of weaving threads that run across the warp threads from selvedge to selvedge.")]), _vm._v(" "), _c('p', {
    staticClass: "box-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grain")])]), _vm._v(" "), _c('p', {
    staticClass: "box-2"
  }, [_vm._v("The direction of the warp or weft of the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "box-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bias")])]), _vm._v(" "), _c('p', {
    staticClass: "box-2"
  }, [_vm._v("An oblique direction to the warp and the weft. The true bias is at an angle of 45° from both the warp and weft. A bias cut is also known as cutting on the cross.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most fabrics will have the print running true to the selvedge. In some cases, it is preferable to pleat the fabric down the selvedge. It will then be necessary to cut all pattern pieces this way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In some instances the best solution can be to pleat the fabric following the print rather than the grain. It is often useful to pleat using half space rows as the pleats are more likely to bubble and twist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plump, round pleats are a pleasure to smock on but not all fabrics have sufficient body to give a satisfactory result. Round pleats occupy more space, therefore less fabric is required to provide a good working surface.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are two easy ways to add body to fabric:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Starch and press the area that is to be pleated with a good quality starch. Several light sprays are preferable to one soaking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Fuse lightweight interfacing across the back of the area to be pleated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Unwashed fabric contains sizing or finishing that increases the body of the fabric. Avoid pre-washing unless it is necessary as the sizing will hold the pleats nicely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pre-wash interfacing if it is recommended by the manufacturer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Layering fabric will also provide a good working surface as you will be stitching through a double thickness. Choose fabrics that can be laundered in the same way.")])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Types of fabric")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following fabrics are the most commonly used for smocking.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Batiste")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Soft, fine, lightweight fabric named after the French weaver, Jean Batiste. It has a slightly heavier fibre gauge and density than voile, but is still a translucent fabric suitable for similar applications to voile. Easy to pleat, it may be made of cotton, linen, silk, synthetic or blended fibres. Cotton or cotton blends can be handwashed. Silk batiste should be drycleaned.")]), _vm._v(" "), _c('div', {
    staticClass: "box3"
  }, [_c('p', {
    staticClass: "box-1"
  }, [_vm._v("Hint")]), _vm._v(" "), _c('p', {
    staticClass: "box-2"
  }, [_vm._v("Always pleat fabric before selecting your threads. Pleated fabric can look quite different from unpleated fabric.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Broadcloth")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fine, tightly woven fabric with a faint rib. Originally made of mercerised cotton, it is now made of any fibre. It is easy to pleat and care advice corresponds to the type of fibre – cotton and cotton blends can be gently machine-washed; silk should be drycleaned.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Challis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A soft, lightweight, plain weave fabric, originally made from wool but now also manufactured from synthetic fibres. It is often printed in small floral or paisley designs and is suitable for winter garments. Wool challis feeds through the pleater with relative ease, but the pleats ‘pop’ out readily. When pleating, use half space rows and pack and steam the pleats to help them hold their shape. Using a dense smocking design is recommended for the same reason. Wool challis should be drycleaned to minimise shrinkage. Synthetic challis fabrics should be laundered according to the manufacturer’s instructions.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg10.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The First Step")]), _vm._v(", AS&E 41")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chambray")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A cotton, silk or cotton-blend, plain weave fabric where the warp threads are coloured (blue is common) and the weft threads are white. It may incorporate checks, stripes or small figured or dobby patterns and is generally a medium weight fabric used for garments. Most chambray fabrics should pleat easily. Cotton and cotton blends can be machine-washed.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg10-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eliza")]), _vm._v(", AS&E 37")])])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Corduroy")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A corded fabric where the weft pile forms ribs, also known as wales, that have been sheared or woven to produce a smooth, velvet-like nap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The wales vary in width from jumbo to the very fine feather-wale. Traditionally made of cotton, it is made of many different fibres today. Featherwale, also known as 21 wale, or baby wale is the most suitable corduroy for smocking and is easy to pleat. Slightly heavier weight corduroys may be used but test pleating is strongly recommended, otherwise bent and broken pleater needles may result.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prevent excessive fraying by overlocking or machine neatening cut edges. As this fabric has a nap, follow pattern layouts according to the ‘with nap’ instructions. Generally hand- or machine-wash in warm water, and iron on the wrong side of the fabric to avoid crushing the pile.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg11.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Precious Coral")]), _vm._v(", AS&E 44")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg11-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gifts from the Sea")]), _vm._v(", AS&E 47")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Crêpe")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A term used to describe all types of fabrics regardless of fibre composition that have a crinkly, crimped or grained surface. The pleatability and care instructions will vary depending on the fibres used, density of the weave and stiffness of the fabric. Test-pleat before beginning a project and follow the manufacturer’s care instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Damask")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fabric woven on a Jacquard loom to produce satin weave in areas of pattern against a plain or twill background so that light will be reflected from the fabric. It may be made from cotton, linen, silk or synthetics. Traditionally used for table linens, upholstery and draperies, light- and medium-weight damask can be used for special occasion garments. As fabric fibre content varies, test pleat a sample before beginning a project. Launder according to the manufacturer’s instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Drill")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A sturdy, twill weave, medium- to heavyweight fabric, usually made of cotton or cotton blends. It is often used for work clothes or uniforms. Test pleat to determine suitability. It can be machine-washed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Georgette")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A sheer lightweight fabric made with a crêpe thread often of silk or synthetic fibres. It is very similar in appearance to chiffon and is commonly used for dresses, blouses and lingerie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It can be difficult to pleat, due to the nature of the fabric. Gently hand- or machine-wash synthetic georgette – silk should be drycleaned.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gingham")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is a closely woven, light to medium weight, plain weave fabric using a dyed warp thread. At least two colours are used to produce a checked appearance. Most often, cotton or cotton blend fibres are used.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gingham pleats easily with a pleater but is often pleated by hand to achieve a uniform appearance. Gentle hand- or machine-washing is recommended.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg11-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Elspeth")]), _vm._v(", AS&E 25")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg12.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Beach Baby")]), _vm._v(", AS&E 50")])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Knits")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This includes fabrics made by loops joining loops in successive rows. There are a number of different types of knit fabrics in various weights and fibre types, from fine interlock knits to heavy weight rugby. Velour knits have a rich, napped surface. Take care not to stretch the fabric when feeding through the pleater.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Printed fabrics may prove difficult to pleat depending on the medium used for the print. Knit fabrics are very comfortable to wear due to their elastic nature. Fine or medium-weight fabrics are most suited to smocking. Gentle hand- or machine-washing is recommended.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lace")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A decorated cotton or synthetic fibre fabric often made on a background of net or with no background fabric at all, commonly with floral or geometric motifs in the design. There are many different types of lace from very fine, sheer fabrics, to those that are heavy and ornately patterned. The fabric can be made by hand or machine. Fine laces with relatively open designs pleat easily. Laundering requirements may vary from handwashing to drycleaning depending upon the delicacy and composition of the lace fabric used.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg12-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Faraway Thoughts")]), _vm._v(", AS&E 38")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lawn")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A moderately lightweight, opaque plain weave fabric originally made from linen, but usually made today from combed cotton or cotton blends and synthetic fibres. It has a crisp, crease-resistant finish. Lawn is slightly heavier than batiste but can be used for similar purposes. It can be difficult to pleat if densely woven, e.g. Liberty Tana lawn. Gently hand- or machine-wash.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Linen")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This fabric is manufactured from the flax plant. It is made in various weights for different purposes. Handkerchief linen is a fine, sheer fabric used for clothing and is beautifully comfortable to wear. Linen fabrics usually pleat easily. Linen has a high shrinkage rate and should be pre-washed before beginning a garment. It may be laundered by hand or machine, or drycleaned if required. Linen will require a hot steam iron due to its tendency to crease easily.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Net")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fabric that is constructed by knotting and looping a continuous thread into an open mesh. It may be composed of cotton or synthetic fibres. It has a stiff texture and is often used to support other fabrics in areas such as puffed sleeves or skirts. Care will vary depending on the fibre composition, so follow the manufacturer’s advice.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Organdy/organza")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Originally, organdy was a sheer, lightweight, cotton fabric with a stiff finish. The same fabric made of silk was referred to as organza. The two names are now interchangeable and these fabrics are also manufactured with synthetic fibres. It is used for special occasion garments and pleats easily. Drycleaning is recommended.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg12-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tinkerbelle")]), _vm._v(", AS&E 30")])])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Piqué")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A crisp, medium- to heavyweight fabric woven with small, raised geometric patterns, usually made of cotton or cotton/synthetic blends. White piqué is often used for collars and cuffs on dresses and blouses but can be used for whole garments. It can be pleated easily. Gently hand- or machine-wash.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg13.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("My Pretty Maid")]), _vm._v(", AS&E 48")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg13-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Liquid Gold")]), _vm._v(", AS&E 58")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Poplin")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A plain weave fabric with much more warp yarn than weft, and it has a characteristic warp rib appearance. It is best recognised as shirting fabric and may be composed of cotton, synthetics or blends. Due to its densely woven nature, poplin can be difficult to pleat. Warm hand or machine washing is recommended.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ramie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This name refers to a fibre from the nettle or Urtica family of plants mainly grown in China, Indonesia, Taiwan and Japan. It is sometimes blended with cotton for the manufacture of less expensive clothing and is often confused with linen. Its pleatability and care are similar to linen but if blended with other fibres, the care instructions will alter to cater for those.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sateen")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A strong, lustrous, satin weave fabric made of cotton as distinguished from other satin weave fabrics made of silk or synthetic fibres. It drapes beautifully and is suitable for gowns, blouses and lingerie. Pleatability may vary depending on the density and weight of the fabric. Densely woven fabrics will be difficult to pleat. Drycleaning is recommended.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Satin")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Refers to fabrics made using another basic weave pattern, characterized by smooth, lustrous surfaces with longer warp threads ‘floating’ over the top of the weft threads. This produces a beautiful fabric, made of either silk or synthetic threads. It is made in a variety of weights and can be shiny on one side or both.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Satin is most often used for special occasion garments or lingerie. Its pleatability can vary from easy to difficult depending on the thickness of the fabric and the fibres used. Usually, natural fibre satins will pleat more easily than synthetic satins. When in doubt, test pleat the fabric. Satin fabrics are often easily bruised, so dryclean natural fibres and handwash synthetics.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Seersucker")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A fabric usually of cotton, cotton blends or nylon. It is made to have a crinkled effect in the lengthwise direction by holding some threads tightly and other threads loosely during the weaving process. Seersucker effects are not lost during laundering and wear. It is easy to pleat and can be hand- or gently machine-washed.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg13-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Happy Child")]), _vm._v(", AS&E 55")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg14.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Little Flowergirl")]), _vm._v(", AS&E 39")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Silk dupion")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Also known as dupioni, this is a lustrous, papery silk fabric made from fibres of silk worm cocoons in which two worms have nested together, creating a double fibre. The resulting fabric has an irregular texture with characteristic ‘slubs’. A luxury fabric often used for special occasion garments, silk dupion pleats moderately easily, but sometimes pleats have a tendency to ‘pop’ after pleating and can be difficult to restore. Packing the pleats tightly and steaming before smocking may help prevent this. As with most silks, the recommended care is drycleaning.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Silk Fuji")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A fine, soft, plain weave silk fabric with beautiful draping qualities. It is ideal for special occasion garments and pleats easily. It should only be drycleaned to maintain fabric finish.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg14-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mint Julep")]), _vm._v(", AS&E 24")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Speciality fabrics")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fabrics with surface detail such as flocking, embroidery or beading, require special preparation to allow them to be pleated successfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flocked fabrics can be pleated with the needles avoiding the spots or the spots can be removed from the area to be smocked before pleating.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beaded fabrics must have the beads removed before the fabric is put through the pleater. These can be re-attached after the smocking is complete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Embroidered fabrics may be pleated if the embroidered surface is not too thick for the pleater needles to go through. Test-pleat a sample to determine suitability.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Taffeta")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A plain weave, crisp fabric with a lustrous surface and characteristic rustling sound, originally made of silk but now also made of synthetic fibres. It is often used for special occasion garments and is manufactured in a variety of types. Moiré and paper taffeta are two examples. Pleatability may vary depending on the weight, composition and density of the fabric. Test-pleat a sample to determine suitability. Drycleaning is recommended.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg14-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Princess Charming")]), _vm._v(", AS&E 58")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tulle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A very fine net, formerly made only of silk, tulle is now also made of cotton and nylon and is a favourite for bridal veils. It may be used as an overlay and pleated together with another fabric such as silk. Pleat slowly and carefully to avoid bent and broken needles. Care will vary depending on the composition of the fibre, so follow the advice given by the manufacturer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Twill")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A twill fabric refers to one of the three basic fabric weave patterns and is characterised by its diagonal line effect. It includes many easily recognisable fabrics, such as gaberdine, denim, some flannel fabrics and many others. A twill weave is often used for winter weight garments. Some twills are brushed on the wrong side to create a soft, napped surface. Fine twill fabrics are commonly used for smocked garments and pleat easily. The fibre used in twill fabrics varies, so the care instructions from the manufacturer should be followed.")])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Velvet")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is a medium-weight, woven fabric with a short, dense pile. Originally made of silk, it is now made of many different fibres and is usually regarded as a luxury fabric for special occasion garments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are a number of different varieties of velvet derived from various treatments to the pile in manufacture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Good quality velvet is usually not difficult to pleat, however, test-pleating a sample before beginning a project is recommended. Follow pattern layouts according to ‘with nap’ instructions and place pins into the seam allowances only to avoid damaging the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Position pins close together to prevent the fabric layers from ‘walking’ on one another. Finger press seams. If necessary, carefully steam press on the wrong side without touching the fabric surface.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ironing directly on the fabric can cause irreparable damage to the pile. To raise a flattened surface, hang the garment in a steamy room and brush the pile with a velvet brush. Velvet should always be drycleaned.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg15.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lily May")]), _vm._v(", AS&E 29")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Velveteen")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Velveteen differs from velvet in that the pile in velvet is made with the warp threads, while the pile in velveteen is made with the filling or weft threads. Its characteristics are otherwise similar to velvet and it is manufactured from the same range of fibres, so should be treated in a similar manner.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Voile")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A sheer, lightweight, plain weave fabric made from tightly twisted yarns in a high yarn count construction, the warp of which is two-ply. Voile drapes beautifully, is similar in appearance to organdy and organza and is easy to pleat. It is commonly composed of cotton, polyester, a combination of both fibres, or silk. Pure cotton voile creases easily whereas cotton blends do not. Voile is often used for infant wear, lingerie and blouses. Cotton or cotton blends may be handwashed. Silk voile should only be drycleaned.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg15-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cupcake")]), _vm._v(", AS&E 54")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Wool flannel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A warm, soft, medium- to heavyweight fabric composed of tightly woven twill or plain weave and finished with a light napping on the front, back or both sides of the fabric. Medium-weight wool flannel can be used for clothing, whereas blankets are examples of heavyweight flannel. Used in smocking, medium-weight wool flannel usually pleats easily. Drycleaning is recommended to minimise shrinkage.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg15-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bright Eyes")]), _vm._v(", AS&E 51")])])]), _c('p', {
    staticClass: "noindentc",
    attrs: {
      "id": "sec3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Fabric requirements")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Basic square yoke fabric requirements")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Garment:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Plain calf length skirt, sash, short puffed sleeves with bands and Peter Pan collar.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg16.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxZ"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Size")])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Requirements 112cm (44”) wide")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("3 months (no sash)")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.6m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("1yd 27”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("6 months (no sash)")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.7m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("1yd 31”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("12 months (no sash)")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.8m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("1yd 35”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("18 months")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.1m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 10¾”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("2 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.2m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 14⅝”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.4m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 22½”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("4 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.6m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 30⅜”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("5 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.7m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 34¼”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("6 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.8m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 2¼”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.9m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 6¼”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("8 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("3.0m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 10”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("9 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("3.1m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 14”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("10 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("3.2m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 18”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Note: for long sleeves add 20cm (8h) for each size.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Garment:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Plain calf length skirt, sash and short puffed sleeves with contrasting Peter Pan collar and sleeves bands.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg16-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxZ"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Size")])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Requirements 112cm (44”) wide")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("3 months (no sash)")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.4m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("1yd 19”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("6 months (no sash)")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.5m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("1yd 23”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("12 months (no sash)")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.6m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("1yd 27”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("18 months")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.9m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 10¾”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("2 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.0m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 6¾”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.2m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 14⅝”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("4 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.4m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 22½”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("5 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.5m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 26½”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("6 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.6m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 30⅜”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.7m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 34¼”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("8 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.8m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 2¼”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("9 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.9m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 6¼”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("10 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("3.0m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("3yd 10”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Note: for long sleeves add 20cm (8”) for each size. The contrast collar and cuffs require an additional 25cm (10”) for each size.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Bishop fabric requirements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Garment:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Plain calf length skirt and short puffed sleeves with sleeve bands.")]), _vm._v(" "), _c('div', {
    staticClass: "boxZ"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Size")])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Requirements 112cm (44”) wide")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("3 months")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.5m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("1yd 23”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("6 months")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.6m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("1yd 27”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("12 months")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.8m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("1yd 35”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("18 months")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("1.9m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 4¾”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("2 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.0m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 6¾”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.2m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 14⅝”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("4 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.4m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 22½”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_vm._v("5 years")]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("2.6m"), _c('span', {
    staticClass: "space"
  }, [_vm._v("2yd 30⅜”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Note: for long sleeves add 20cm (8”) for each size.")])])])])])]), _c('p', {
    staticClass: "noindentt",
    attrs: {
      "id": "sec4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Interfacings and interlinings")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Interfacings and interlinings are used to stiffen, stabilise, strengthen and support some elements of a smocked garment, particularly collars, cuffs and button bands. The entire front yoke and back bodice pieces can be interfaced if the fabric has ‘show through’. This prevents the seams from being visible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fusible interfacing can also be used to stabilise a smocked piece before cutting out. This prevents the smocked surface from stretching when the garment is constructed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interfacings, fusible or non-fusible, woven or non-woven, come in a range of weights. Fusible interfacings are often chosen for their ease of use, but they are unsuitable for napped fabrics such as velvet or velveteen and any fabric that would be damaged by the heat and pressure of fusing. When buying fusible interfacing, ask for instructions for fusing it correctly. These are often supplied by the manufacturer. Take special note of the iron setting and time required. Use a pressing cloth to protect the fabric if necessary. Ensure the fusible side of the interfacing is facing the fabric, not the iron, before pressing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interlinings are used when soft support, rather than stiffness, is required or if the fabric is transparent. An interlining is often made from the same fabric as the garment. The layers of fabric are tacked together and subsequently treated as one.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt",
    attrs: {
      "id": "sec5"
    }
  }, [_vm._v("Machine sewing thread")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Choosing the correct thread for constructing a garment is just as important as choosing the fabric and smocking design. Machine threads are available in various fibres and weights from extra fine (100) pure cotton to heavy (30) cotton or polyester topstitching threads.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cotton thread is numbered to indicate the thickness (80, 60, 50, 30) and if there is a second number (60/2), this indicates the number of plies used to make the thread – in this case, two.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Polyester thread uses a different sizing system – 100 polyester is not as fine as 100 cotton – but the higher the number, the finer the thread.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Always buy the best quality thread available and store it away from sunlight and protected from dust and insects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are threads especially for fine or heirloom sewing. Fine weight threads make stitches that are less visible on fine fabrics. Pure cotton is a weaker fibre than polyester. Better quality cotton threads are made using long staple Egyptian cotton and the thread can be mercerised to increase its strength and lustre.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Good quality long staple polyester thread can be used for most tasks and is available in a variety of different finishes.")])]), _c('h3', {
    staticClass: "subtitle",
    attrs: {
      "id": "sec6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Patterns")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Determine the correct pattern by taking the relevant measurements and comparing them with those on the standard sizing chart. Very few children will fit the sizing for their age exactly. Use the size that best fits your child’s chest measurement. You may need to make alterations to the length of the garment. Carefully trace the pattern onto tracing paper or lightweight interfacing including all pattern markings. Accuracy is very important to ensure the proper fit of the garment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If changing the number of smocking rows from that specified in the pattern, you will need to adjust the length of the back bodice to ensure that the lowest row of smocking lines up with the back bodice/skirt seam.")]), _vm._v(" "), _c('p', {
    staticClass: "tnote"
  }, [_vm._v("Standard body measurements* for children (metric and imperial conversions)")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("* "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("based on Australian standards")])])]), _c('p', {
    staticClass: "tnote"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Standard body measurements* for children (imperial, to the nearest half-inch)")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg19.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg19-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Cutting layout")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The cutting layout is designed so that all the required pieces of the garment can be cut in the most economical way and on the correct grainline.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Take special care to note whether the fabric is cut on the fold or as a single layer. Pattern pieces that need to be mirror imaged before cutting are indicated on the cutting layout.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg19-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Pinning the pattern to the fabric")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Press the fabric to remove all creases. Lay the fabric on a flat surface. Fold with right sides together and the selvedges parallel. Following the cutting layout, pin the pattern pieces in place. When cutting plaids, stripes and spots on the fold, ensure that both fabric layers are properly aligned.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg19-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Cutting out")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Accuracy in cutting is important to ensure that all pattern pieces are accurately cut out so they fit together correctly. Use good quality, sharp dressmaking scissors and cut with the scissors held at a right angle to the fabric. Use the full blade as this ensures a straight cut edge. Fabrics that fray excessively should have the cut edges neatened.")]), _vm._v(" "), _c('p', {
    staticClass: "tnote"
  }, [_vm._v("* "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("based on North American standards")])])]), _c('h3', {
    staticClass: "subtitle",
    attrs: {
      "id": "sec7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Transferring markings")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transfer pattern markings onto the fabric using one of the following methods.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Tailor’s tacks")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tailor’s tacks are the traditional method for transferring markings onto fabric. Use thread in a contrasting colour.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg20.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaptionn"
  }, [_vm._v("1 Thread the needle with a double length of thread.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg20-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaptionn"
  }, [_vm._v("2 Take the thread to the back at A leaving a 3cm (1⅛”) tail. Emerge at B.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg20-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaptionn"
  }, [_vm._v("3 Take thread to back at C, leaving a 6cm (2½”) loop. Emerge at D.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg20-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaptionn"
  }, [_vm._v("4 Leaving a 3cm (1⅛”) tail, cut the thread and loop.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg20-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaptionn"
  }, [_vm._v("5 Separate the fabric layers.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg20-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaptionn"
  }, [_vm._v("6 Cut the threads.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Marking seamlines")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To mark seamlines, unthread your sewing machine and stitch a line at the seamline. The needle will leave a row of small holes indicating the seamline position.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Water-soluble and fade-away markers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make a small hole through the pattern piece at the marked point. Make a mark through the hole. Push a pin though both layers of fabric at the marked point. Mark the second side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Tailor’s pencil and chalk")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Suitable for dark fabrics, use these in the same way as the markers.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1addc50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_General_information.vue
// module id = 72
// module chunks = 0